import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { withRouter } from 'react-router';
import { Select } from 'semantic-ui-react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import { getSitesAction } from '../state/sites/actions';
import { SelectField } from './SemanticWrapper';
import { Fragment } from 'react';

import 'Styles/components/siteComponentStyle.less';

class SiteComponentContainer extends Component {
  static propTypes = {
    sitesLoading: PropTypes.bool.isRequired,
    siteOptions: PropTypes.array,
    onChange: PropTypes.func,
    isForm: PropTypes.bool,
    name: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    selectFirst: PropTypes.bool,
    isAllRequired: PropTypes.bool,
    filterSites: PropTypes.func,
    className: PropTypes.string,
    label: PropTypes.string,
    showAllActiveSites: PropTypes.bool,
    siteMasterTypeIds: PropTypes.array,
    alternateProvisionTypes: PropTypes.array,
    isLicensed: PropTypes.bool,
    checkIsLicensed: PropTypes.bool,
    isActive: PropTypes.bool,
    isAllValueZero: PropTypes.bool,
    fluid: PropTypes.bool,
    isPrimary: PropTypes.bool,
    fetchAllSites: PropTypes.bool,
  };

  static defaultProps = {
    siteOptions: null,
    onChange: () => {},
    isForm: false,
    name: null,
    loading: false,
    disabled: false,
    selectFirst: false,
    isAllRequired: true,
    filterSites: null,
    className: undefined,
    label: 'Site',
    showAllActiveSites: false,
    // In usage,need to show site which are school and kitchen.In warehouse reports need to show only warehouse and kitchen sites.
    siteMasterTypeIds: [1],
    alternateProvisionTypes: [],
    isLicensed: true,
    checkIsLicensed: true,
    isActive: true,
    // As backend take value as zero for all sites.
    isAllValueZero: false,
    fluid: false,
    isPrimary: false,
    fetchAllSites: false,
  };

  state = {
    filteredSiteOptions: [],
    selected: null,
  };

  componentDidMount() {
    const {
      isForm,
      name,
      getSitesAction,
      siteOptions,
      fetchAllSites,
    } = this.props;

    if (isForm && !name) {
      throw new Error(`'Name' is required when 'isForm' = true`);
    }

    // Sites will be passed into the component or loaded automatically from commonStateSiteOptions.
    if (!Array.isArray(siteOptions)) {
      getSitesAction(fetchAllSites);
    } else {
      let filteredSiteOptions = this.getFilteredSiteOptions();
      this.buildOptions(filteredSiteOptions);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      selectFirst,
      siteOptions,
      commonStateSiteOptions,
      isAllRequired,
    } = this.props;

    if (
      siteOptions !== prevProps.siteOptions ||
      commonStateSiteOptions !== prevProps.commonStateSiteOptions ||
      isAllRequired !== prevProps.isAllRequired
    ) {
      let filteredSiteOptions = this.getFilteredSiteOptions();

      if (selectFirst || filteredSiteOptions.length === 1) {
        this.setState({ selected: null }, () =>
          this.buildOptions(filteredSiteOptions)
        );
        return;
      }
      this.buildOptions(filteredSiteOptions);
    }
  }

  buildOptions = (filteredSiteOptions) => {
    const { onChange, selectFirst } = this.props;
    const controlledValue = this.props.value;

    filteredSiteOptions = this.addAllOption(filteredSiteOptions);

    this.setState({
      filteredSiteOptions,
    });

    if (filteredSiteOptions.length) {
      let value;

      // If this is the first loop and selected is null we should set selected to the first option if there is only one option or selectFirst is true.
      if (
        !this.state.selected &&
        (filteredSiteOptions.length === 1 || selectFirst)
      ) {
        value = filteredSiteOptions[0].value;
      }

      // If the selected option is controlled save it to state. Override previous value.
      if (controlledValue) {
        value = controlledValue;
      }

      if (value) {
        this.setState({ selected: value });
        onChange(value);
      }
    }
  };

  getFilteredSiteOptions = () => {
    const {
      isPrimary,
      siteOptions,
      filterSites,
      commonStateSiteOptions,
      showAllActiveSites,
      siteMasterTypeIds,
      isLicensed,
      isActive,
      checkIsLicensed,
      alternateProvisionTypes,
    } = this.props;

    // If site options is passed to the component use it rather than using the default common state site options.
    let filteredOptions = siteOptions || commonStateSiteOptions;

    if (filterSites) {
      filteredOptions = filteredOptions.filter(filterSites);
    }
    //showAllActiveSites is used to show all active sites,
    filteredOptions = filteredOptions.reduce((carry, site, i) => {
      const showActiveSite = showAllActiveSites && site.IsActive;
      if (
        showActiveSite ||
        (site.IsActive === isActive &&
          siteMasterTypeIds.indexOf(site.SiteMasterTypeId) !== -1 &&
          (checkIsLicensed ? site.IsLicensed === isLicensed : true) &&
          (isPrimary ? site.Id === site.PrimarySiteId : true) &&
          (alternateProvisionTypes.length > 0
            ? alternateProvisionTypes.indexOf(site.AlternateProvisionTypeId) !==
              -1
            : true))
      ) {
        return [
          ...carry,
          {
            value: site.Id,
            key: i + site.Id,
            text: site.Id + ' ' + site.Description,
            sitegroupid: site.SiteGroupId,
          },
        ];
      }
      return carry;
    }, []);

    return filteredOptions;
  };

  addAllOption = (options) => {
    // Add in the 'ALL' option if requested.
    return options.length > 1 && this.props.isAllRequired
      ? [
          this.props.isAllValueZero
            ? { value: '0', text: 'All', key: '0' }
            : { value: 'ALL', text: 'ALL', key: 'valueALL' },
          ...options,
        ]
      : options;
  };

  render() {
    const {
      name,
      sitesLoading,
      onChange,
      style,
      tabIndex,
      loading,
      disabled,
      upward,
      className,
      isForm,
      label,
      fluid,
    } = this.props;

    const { filteredSiteOptions, selected } = this.state;

    return (
      <div>
        {isForm ? (
          <Field
            name={name}
            component={SelectField}
            type="text"
            label={label}
            options={filteredSiteOptions}
            style={style}
            loading={sitesLoading || loading}
            disabled={disabled}
            onChange={(e, value, preValue, field) => {
              onChange(value, preValue, field, e);
            }}
            upward={upward}
            tabIndex={tabIndex}
            className={className}
            fluid={fluid}
          />
        ) : (
          <Fragment>
            {label && <label className="sitedropdown-label">{label}</label>}
            <Select
              search
              options={filteredSiteOptions}
              value={selected && selected}
              loading={sitesLoading || loading}
              style={{ width: '100%' }}
              onChange={(e, { value }) => {
                this.setState({ selected: value });
                return onChange(value, e);
              }}
              disabled={disabled}
              tabIndex={tabIndex}
              upward={upward}
              fluid={fluid}
            />
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ CommonState }) => {
  return {
    commonStateSiteOptions: get(CommonState.sites.info, 'Data', []),
    sitesLoading: CommonState.sites.loading,
  };
};

const mapDispatchToProps = {
  getSitesAction,
};

export const SiteComponent = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SiteComponentContainer)
);



// WEBPACK FOOTER //
// ./src/common/SiteComponent.js